<template>
  <span />
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { UserService, UserConstants } from '@/core/user';
import { VendorUserService } from '@/core/vendor-user';
import { AuthRoutes } from '@/auth/mixins';

import EventBus from '@/event-bus';

export default {
  mixins: [
    AuthRoutes,
  ],
  computed: {
    ...mapGetters(['hasAuthToken']),
    ...mapState(['user', 'vendorUser']),
    ...mapState({
      adminRedirectUrl: state => state.config.adminRedirectUrl,
      portalRedirectUrl: state => state.config.portalRedirectUrl,
      workerRedirectUrl: state => state.config.workerRedirectUrl,
    }),
    stringQueryParams() {
      return ['invitation_code', 'sent_invitation_uuid', 'client_uuid', 'location_uuid'].map((key) => {
        const value = this.$route.query[key];
        return value ? `${key}=${value}` : '';
      })
        .filter(query => !!query)
        .join('&');
    },
    defaultRedirectUrl() {
      const redirectUrlMapping = {
        [UserConstants.user_type.administrator.key]: this.adminRedirectUrl,
        [UserConstants.user_type.manager.key]: this.adminRedirectUrl,
        [UserConstants.user_type.vendor.key]: this.portalRedirectUrl,
        [UserConstants.user_type.worker.key]: this.workerRedirectUrl,
      };
      const redirectUrl = redirectUrlMapping[this.user.user_type.name];
      return this.stringQueryParams ? `${redirectUrl}/#/?${this.stringQueryParams}` : redirectUrl;
    },
  },
  created() {
    this.checkEmailConfirmedState();
  },
  methods: {
    async checkEmailConfirmedState() {
      try {
        await UserService.getUser();
        const vendorUser = this.vendorUser || await VendorUserService.get(this.user.uuid);
        const vendorUuid = _.get(vendorUser, 'vendor.uuid');

        if (!this.user.confirmed && this.user.user_type.name === UserConstants.user_type.vendor.key && !vendorUuid) {
          this.$router.push(this.routes.emailVerification);
        } else {
          const redirectUrl = this.$route.query.redirect_to || this.defaultRedirectUrl;
          if (redirectUrl) {
            EventBus.$emit('show-splash-screen');
            window.open(redirectUrl, '_self');
          }
        }
      } catch (error) {
        if (!this.hasAuthToken) {
          this.$router.push(this.routes.login);
        }
      }
    },
  },
};
</script>
